// import http from 'assets/js/Base/http.js'
// import constGlobal from 'assets/js/ConstGlobal'
// import iviewPlugin from 'iview'
import { Message } from 'view-ui-plus'
const common = {
    // 兼容IE的打开新页面的方式
    openUrl(url) {
        var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
        var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
        if (isIE) {
            // 如果为IE 构造一个虚拟的a标签 以便于跳转到对应的URL
            var aLink = document.createElement('a')
            aLink.href = url
            aLink.setAttribute('target', '_blank')
            document.body.appendChild(gotolink)
            aLink.click()
        } else {
            window.open(url)
        }
    },
    j2s(obj) {
        return JSON.stringify(obj)
    },
    cloneJson(obj) {
        return JSON.parse(JSON.stringify(obj))
    },
    // 删除左右两端的空格
    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, '')
    },
    toastMsg(msg, type) {
        switch (type) {
            case 'normal':
                Message.error(msg)
                break
            case 'success':
                Message.success(msg)
                break
            case 'warning':
                Message.warning(msg)
                break
            case 'error':
                Message.error(msg)
                break
            default:
                Message.config({ duragion: 20 })
                Message.warning(msg)
                break
        }
    },
    sessionSet(name, obj) {
        return sessionStorage.setItem(name, JSON.stringify(obj))
    },
    sessionGet(name) {
        return JSON.parse(sessionStorage.getItem(name))
    },
    /* isLogin() {
        let url = constGlobal.MainHost + '/isLogin'
        http.methods.apiGet(url).then(res => {
            if (res == 0) { // 0：未登录 ；1：已登录
                sessionStorage.removeItem('activeMenu')
                sessionStorage.removeItem('menuId')
                let url = constGlobal.MainHost + '/logout'
                window.location.href = url
            }
        })
    }, */
    wxSetTitle(title) {
        if (title === undefined || window.document.title === title) {
            return
        }
        document.title = title
        var mobile = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(mobile)) {
            var iframe = document.createElement('iframe')
            iframe.style.display = 'none'
                // 替换成站标favicon路径或者任意存在的较小的图片即可
            iframe.setAttribute('src', '')
            var iframeCallback = function() {
                setTimeout(function() {
                    document.body.removeChild(iframe)
                }, 5000)
            }
            iframe.addEventListener('load', iframeCallback)
            document.body.appendChild(iframe)
        }
    }
}

export default common